"use client";
import { Banner } from "@/components/banner";
import ImageModal from "@/components/image-modal";
import Image from "next/image";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import { useTranslations } from "next-intl";

export default function CafeAguedaPage() {
  const t = useTranslations("Portfolio.design.cafeAgueda");
  const imageT = useTranslations("ImagesAlt.portfolioProjects.cafeAgueda");
  return (
    <main className="bg-background-grey flex flex-col gap-24 pb-24">
      <Banner
        title={t("banner.title")}
        titleYellow={t("banner.titleYellow")}
        description={t("banner.description")}
        imageUrl="/portfolio-projects/cafe-agueda/menu-a.jpg"
        imageAlt={imageT("menu-b")}
        goBackButton={true}
        date={t("banner.date")}
        projectType={t("banner.type")}
      />

      <section className="px-5 flex flex-col items-center">
        <div className="max-w-4xl w-full flex flex-col gap-6 justify-center">
          <div className="max-w-4xl w-full border-l-5 pl-5">
            <h1>{t("sections.introduction.title")}</h1>
          </div>
          <div className="flex flex-col gap-6 flex-nowrap">
            <p>{t("sections.introduction.paragraph1")}</p>
            <p>{t("sections.introduction.paragraph2")}</p>
            <p>{t("sections.introduction.paragraph3")}</p>
            <p>{t("sections.introduction.paragraph4")}</p>
          </div>
        </div>
      </section>

      <section className="px-5 flex flex-col items-center">
        <div className="max-w-4xl w-full flex flex-col gap-6 justify-center">
          <div className="max-w-4xl w-full border-l-5 pl-5">
            <h1>{t("sections.design.title")}</h1>
          </div>
          <div className="flex flex-col gap-6 flex-nowrap">
            <p>{t("sections.design.paragraph1")}</p>
            <p>{t("sections.design.paragraph2")}</p>
            <p>{t("sections.design.paragraph3")}</p>

            <div className="grid grid-cols-3 gap-3 mx-5 my-10">
              <ImageModal
                src="/portfolio-projects/cafe-agueda/it-1.jpg"
                alt={imageT("it-1")}
                width={500}
                height={500}
              />
              <ImageModal
                src="/portfolio-projects/cafe-agueda/it-2.jpg"
                alt={imageT("it-2")}
                width={500}
                height={500}
              />
              <ImageModal
                src="/portfolio-projects/cafe-agueda/it-3.jpg"
                alt={imageT("it-3")}
                width={500}
                height={500}
              />
            </div>

            <p>{t("sections.design.paragraph4")}</p>
            <p>{t("sections.design.paragraph5")}</p>

            <div className="grid grid-cols-2 gap-3 mx-5 my-10">
              <ImageModal
                src="/portfolio-projects/cafe-agueda/bean.jpg"
                alt={imageT("bean")}
                width={500}
                height={500}
              />
              <ImageModal
                src="/portfolio-projects/cafe-agueda/pattern.jpg"
                alt={imageT("pattern")}
                width={500}
                height={500}
              />
            </div>

            <p>{t("sections.design.paragraph6")}</p>

            <div className="grid grid-cols-3 gap-3 mx-5 my-10 justify-center items-center">
              <div className="bg-white aspect-square flex justify-center items-center">
                <Image
                  src="/portfolio-projects/cafe-agueda/final.jpg"
                  alt={imageT("final")}
                  width={250}
                  height={250}
                />
              </div>
              <div className="bg-white aspect-square flex justify-center items-center">
                <Image
                  src="/portfolio-projects/cafe-agueda/final.jpg"
                  alt={imageT("final")}
                  width={150}
                  height={150}
                />
              </div>
              <div className="bg-white aspect-square flex justify-center items-center">
                <Image
                  src="/portfolio-projects/cafe-agueda/final.jpg"
                  alt={imageT("final")}
                  width={50}
                  height={50}
                />
              </div>
            </div>

            <p>{t("sections.design.paragraph7")}</p>
            <p>{t("sections.design.paragraph8")}</p>
          </div>
        </div>
      </section>

      <section className="px-5 flex flex-col items-center pb-5">
        <div className="max-w-4xl w-full flex flex-col gap-6 justify-center">
          <div className="max-w-4xl w-full border-l-5 pl-5">
            <h1>{t("sections.application.title")}</h1>
          </div>
          <div className="flex flex-col gap-6 flex-nowrap">
            <p>{t("sections.application.paragraph1")}</p>
            <p>{t("sections.application.paragraph2")}</p>

            <div className="grid grid-cols-3 gap-3 mx-5 my-10">
              <div className="bg-[#3F0D0D] p-5 rounded flex justify-center font-bold">
                <label>#3F0D0D</label>
              </div>
              <div className="bg-[#8E5F4B] p-5 rounded flex justify-center font-bold ">
                <label>#8E5F4B</label>
              </div>
              <div className="bg-[#EED9C4] p-5 rounded flex justify-center font-bold text-black">
                <label>#EED9C4</label>
              </div>
            </div>

            <p>{t("sections.application.paragraph3")}</p>

            <div className="grid grid-cols-2 gap-3 mx-5 my-10">
              <ImageModal
                src="/portfolio-projects/cafe-agueda/menu-a.jpg"
                alt={imageT("menu-a")}
                width={500}
                height={500}
              />
              <ImageModal
                src="/portfolio-projects/cafe-agueda/menu-b.jpg"
                alt={imageT("menu-b")}
                width={500}
                height={500}
              />
            </div>

            <p>{t("sections.application.paragraph4")}</p>
            <div className="mx-5 my-10">
              <LiteYouTubeEmbed
                id="ucycdn5wtzE"
                title="YouTube video player"
                noCookie={true}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="px-5 flex flex-col items-center">
        <div className="max-w-4xl w-full flex flex-col gap-6 justify-center">
          <div className="max-w-4xl w-full border-l-5 pl-5">
            <h1>{t("sections.conclusion.title")}</h1>
          </div>
          <div className="flex flex-col gap-6 flex-nowrap">
            <p>{t("sections.conclusion.paragraph1")}</p>
            <p>{t("sections.conclusion.paragraph2")}</p>
          </div>
        </div>
      </section>
    </main>
  );
}
